module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.modal) ? _c('div', {
    staticClass: "modal-dialog",
    style: ({
      'z-index': (_vm.modal == 'private') ? 19 : 20
    })
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "dialog"
  }, [(_vm.modal == 'app-market-update') ? _c('app-market-update-modal') : _vm._e(), _vm._v(" "), (_vm.modal == 'login') ? _c('login-modal') : _vm._e(), _vm._v(" "), (_vm.modal == 'contribute') ? _c('contribute-modal') : _vm._e(), _vm._v(" "), (_vm.modal == 'password') ? _c('password-modal') : _vm._e(), _vm._v(" "), (_vm.modal == 'private') ? _c('private-modal') : _vm._e(), _vm._v(" "), (_vm.modal == 'news') ? _c('news-modal') : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loader"
  }, [_c('div', [_vm._v(" ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "img/load.gif"
    }
  })]) : _vm._e()], 1)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fc604f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal-dialog.vue
// module id = 331
// module chunks = 1